import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  user-select: none;
`

export const Separator = styled.div`
  width: 100%;
  height: 0;
`
